import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@e2n/ui/v2';
import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';

import {
  faEllipsisV,
  faPenToSquare,
  faTrashCan,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function FristenActions({
  index,
  className,
}: {
  index: number;
  className?: string;
}) {
  const { t } = useTranslation();
  const { setOpenEditSheet, setFristIndex, setOpenDeleteDialog } =
    useFristenContext();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={className} asChild>
        <Button variant="ghost" iconOnly>
          <FontAwesomeIcon
            icon={faEllipsisV}
            className="text-primary-blue-600 ml-auto"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          showLeftIcon
          leftIcon={<FontAwesomeIcon icon={faPenToSquare} />}

          onClick={() => {
            setOpenEditSheet(true);
            setFristIndex(index);
          }}>
          {t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.editFristDialog.buttonLabel',
          )}
        </DropdownMenuItem>

        <DropdownMenuItem
          showLeftIcon
          leftIcon={<FontAwesomeIcon icon={faTrashCan} />}
          className=" text-error-red-200"
          onClick={() => {
            setOpenDeleteDialog(true);
            setFristIndex(index);
          }}>
          {t(
            'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.buttonLabel',
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
